import React from "react";
import {
  AudienceSplit,
  LandingSection,
  SectionHeader,
} from "./landing/landing-ui";

function WhyFit() {
  return (
    <LandingSection>
      <SectionHeader
        title="When Nivalabs is the right partner"
        lead="We are selective about scope. The goal is a system your team can operate, not a slide deck of AI possibilities."
      />
      <AudienceSplit
        forItems={[
          "You have a concrete workflow with measurable pain (time, errors, throughput)",
          "Systems of record and sample data can be made available for a pilot",
          "Someone owns the process after launch",
          "You want architecture, evaluation, and handoff, not only a prototype",
        ]}
        notForItems={[
          "You only need a marketing demo or one-off chatbot with no data grounding",
          "There is no owner for the workflow or no path to production systems",
          "Success cannot be defined beyond 'explore AI'",
          "You want model research without an operational outcome",
        ]}
      />
    </LandingSection>
  );
}

export default WhyFit;
